import { useReportPost } from "modules/Community/hooks";
import CToast from "../CToast";
import { ButtonConfirm } from "../form-controls";
import { _t } from "core/language";

export type IProps = {
  className?: string;
  creatorId?: number;
  id?: number;
  type?: 'post' | 'comment';
  handleClick?: (e: any) => void;
  onClose?: (e?: any) => void;
};

const CReport = ({
  className,
  creatorId,
  type = 'post',
  id,
  handleClick,
  onClose
}: IProps) => {
  const { handleReportPost } = useReportPost()
  const handleAction = (type: any) => {
    console.log(creatorId, id, 'handleToPage1', type)
    handleClick?.(id)
    CToast(_t("comunity.toats_report"))
    handleReportPost(id)
  }
  

  return (<>
    {type === 'post' ? <ButtonConfirm
      label={_t("comunity.report")}
      classBtn={`w-[104px] ${className}`}
      handleSubmit={() => handleAction('REPORT')}
      submitText={_t("comunity.text_yes")}
      closeText={_t("comunity.text_no")}
      message={
        <div>{_t("comunity.confirm_report")}</div>
      }
      onClose={() => {onClose?.()}}
    > {_t('comunity.report')}</ButtonConfirm> : <ButtonConfirm
      label={_t("comunity.report")}
      classBtn="w-[104px] "
      handleSubmit={() => handleAction('REPORT')}
      submitText={'yes'}
      closeText={'no'}
      message={
        <div>{_t("comunity.confirm_report_comment")}</div>
      }
      onClose={() => {onClose?.()}}
    > <label className="text-[12px] text-[#777777]">{_t('comunity.report')}</label></ButtonConfirm>}
  </>)
}

export default CReport;